export default function convertTextToSlug(text) {
    if (text !== undefined) {
        const slug = text.toLowerCase().replace(/\s+/g, '-');
        const cleanSlug = slug.replace(/[^\w-]/g, '');
        return cleanSlug;
    }
  }
  